// extracted by mini-css-extract-plugin
module.exports = {"userFullName":"PremiumsHistory_userFullName__3Qafq"};